import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const ComplianceStatus = ({ data }) => {
  const [complianceChart, setComplianceChart] = useState({
    series: [
      {
        name: "Critical",
        data: [], // Data for Critical severity
      },
      {
        name: "High",
        data: [], // Data for High severity
      },
      {
        name: "Medium",
        data: [], // Data for Medium severity
      },
      {
        name: "Low",
        data: [], // Data for Low severity
      },
    ],
    options: {
      chart: {
        type: "line", // Change chart type to line
        height: 350,
        toolbar: {
          show: true,
        },
      },
      xaxis: {
        categories: [], // Timestamps will be added dynamically
        labels: {
          style: {
            fontSize: "12px",
          },
          rotate: -90, // Rotate labels 90 degrees counterclockwise
          offsetX: 0,  // Keep horizontal alignment
          offsetY: 0,  // Keep vertical alignment
          align: "center",
        },
        title: {
          text: "Scan Timestamps",
          style: { fontSize: "14px", fontWeight: "bold" },
        },
      },
      yaxis: {
        title: {
          text: "Count",
          style: { fontSize: "14px", fontWeight: "bold", color: "#333" },
        },
      },
      grid: {
        padding: { bottom: 10 },
      },
      colors: ["#f44336", "#ff9800", "#4caf50", "#2196f3"], // Colors for Critical, High, Medium, Low
      markers: {
        size: 5,
      },
      stroke: {
        width: 2,
        curve: "smooth", // Smooth curve for the lines
      },
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
  if (data && data.length > 0) {
    // Group data by scanDate
    const dateGroups = {};
    
    data.forEach((item) => {
      const scanDate = item.scanDate;
      if (!dateGroups[scanDate]) {
        dateGroups[scanDate] = {
          Critical: 0,
          High: 0,
          Medium: 0,
          Low: 0
        };
      }
      
      // Parse severity distribution from the new API response format
      const severityDistribution = JSON.parse(item.severityDistribution || "{}");
      
      // Add to the totals for this date
      dateGroups[scanDate].Critical += severityDistribution.Critical || 0;
      dateGroups[scanDate].High += severityDistribution.High || 0;
      dateGroups[scanDate].Medium += severityDistribution.Medium || 0;
      dateGroups[scanDate].Low += severityDistribution.Low || 0;
    });
    
    // Convert grouped data to arrays for the chart
    const categories = [];
    const criticalData = [];
    const highData = [];
    const mediumData = [];
    const lowData = [];
    
    // Sort dates chronologically
    const sortedDates = Object.keys(dateGroups).sort((a, b) => new Date(a) - new Date(b));
    
    sortedDates.forEach(rawDate => {
      const severities = dateGroups[rawDate];
      // Format the date
      let formattedDate = "Unknown Date";
      if (rawDate) {
        const date = new Date(rawDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "short" });
        formattedDate = `${day}-${month}`;
      }
      categories.push(formattedDate);
      
      // Add severity data
      criticalData.push(severities.Critical);
      highData.push(severities.High);
      mediumData.push(severities.Medium);
      lowData.push(severities.Low);
    });

    // Update the chart with the new categories and data
    setComplianceChart((prevChart) => ({
      ...prevChart,
      options: {
        ...prevChart.options,
        xaxis: {
          ...prevChart.options.xaxis,
          categories, // Update categories with formatted timestamps
        },
      },
      series: [
        { name: "Critical", data: criticalData },
        { name: "High", data: highData },
        { name: "Medium", data: mediumData },
        { name: "Low", data: lowData },
      ],
    }));
  }
}, [data]);


  return (
    <div className="rounded shadow p-3 pb-0" style={{ height: "100%", background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.3)', boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)' }}>
      <h5 className="fw-bold text-muted mb-3" style={{ color: "#333" }}>
        Risk Trends
      </h5>
      <Chart
        options={complianceChart.options}
        series={complianceChart.series}
        type="line"
        height={360}
      />
    </div>
  );
};

export default ComplianceStatus;
